// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(false);
// Module
___CSS_LOADER_EXPORT___.push([module.id, ".grecaptcha-terms[data-v-783f2cbc]{margin-top:8px;font-family:\"Poppins\",sans-serif;font-style:normal;font-weight:400;font-size:14px;line-height:24px;color:#838285}.grecaptcha-terms a[data-v-783f2cbc]{text-decoration:underline}", ""]);
// Exports
module.exports = ___CSS_LOADER_EXPORT___;
